/** 仅检测端内桥接能力；环境和公开 App ID 都不构成用户身份。 */
export function hasFeishuBridge(): boolean {
  if (typeof window === 'undefined') return false;
  const bridge = window as typeof window & { h5sdk?: unknown; tt?: unknown };
  return typeof bridge.h5sdk === 'object' && bridge.h5sdk !== null
    && typeof bridge.tt === 'object' && bridge.tt !== null;
}

export function canAttemptFeishuLogin(appId: string | undefined): boolean {
  return Boolean(appId && hasFeishuBridge());
}

/** UA is only a hint to load the official SDK; the JSAPI is checked afterwards. */
export function canLoadFeishuSdk(appId: string | undefined): boolean {
  return Boolean(appId && (hasFeishuBridge()
    || typeof navigator !== 'undefined' && /Feishu|Lark/i.test(navigator.userAgent)));
}
